import {FC, memo, useEffect} from 'react'
import {ContactStatus, GetContactParams} from '../../../../../services/cellcast.v2.types'
import {Spinner} from 'react-bootstrap'
import {toAbsoluteUrl, defaultRegion} from '../../../../../_metronic/helpers'
import {useLazyGetContactCountQuery} from '../../../../../services/cellcast.v2'
import {GetCurrentData} from '../../../../Utils/_helpers/GetCurrentData'
import {useGetContactCountMutation} from '../../../../../services/cellcast.v3'

type ContactCountPanelProps = {
  params: GetContactParams
  reloadSubscriberCount: boolean
  showAllCount?: boolean
  showSubscriberCount?: boolean
  showUnsubscribeCount?: boolean
  setReloadSubscriberCount: (isReload: boolean) => void
  setParams: (params: GetContactParams) => void
  setTriggerFetch: (fetchStatus: boolean) => void
}

const ContactCountPanel: FC<ContactCountPanelProps> = (props) => {
  const currentUser = GetCurrentData()

  const {
    params,
    reloadSubscriberCount,
    showAllCount,
    showSubscriberCount,
    showUnsubscribeCount,
    setParams,
    setTriggerFetch,
    setReloadSubscriberCount,
  } = props
  const [fetchAll, {data: countAll, isLoading: isCountAllLoading}] = useLazyGetContactCountQuery()
  const [fetchSubscriber, {data: countSubscriber, isLoading: isCountSubscriberLoading}] =
    useLazyGetContactCountQuery()
  const [fetchUnsubscribe, {data: countUnsubscribe, isLoading: isCountUnsubscribeLoading}] =
    useLazyGetContactCountQuery()

  const [fetchAllRegion, {data: countAllRegion, isLoading: isCountAllRegionLoading}] =
    useGetContactCountMutation()
  const [
    fetchSubscriberRegion,
    {data: countSubscriberRegion, isLoading: isCountSubscriberRegionLoading},
  ] = useGetContactCountMutation()
  const [
    fetchUnsubscribeRegion,
    {data: countUnsubscribeRegion, isLoading: isCountUnsubscribeRegionLoading},
  ] = useGetContactCountMutation()

  useEffect(() => {
    if (params.groupId && params.groupId !== '' && showAllCount && showAllCount === true) {
      if (currentUser?.region === defaultRegion) {
        fetchAll({
          groupId: params.groupId,
        })
      } else {
        const regionParam = {
          group_id: params.groupId,
        }
        fetchAllRegion({
          action: 'count_contact',
          data: regionParam,
        })
      }
    }

    if (
      params.groupId &&
      params.groupId !== '' &&
      showSubscriberCount &&
      showSubscriberCount === true
    ) {
      if (currentUser?.region === defaultRegion) {
        fetchSubscriber({
          groupId: params.groupId,
          status: ContactStatus.subscribe,
        })
      } else {
        const regionParam = {
          group_id: params.groupId,
          status: ContactStatus.subscribe,
        }
        fetchSubscriberRegion({
          action: 'count_contact',
          data: regionParam,
        })
      }
    }

    if (
      params.groupId &&
      params.groupId !== '' &&
      showUnsubscribeCount &&
      showUnsubscribeCount === true
    ) {
      if (currentUser?.region === defaultRegion) {
        fetchUnsubscribe({
          groupId: params.groupId,
          status: ContactStatus.unsubscribe,
        })
      } else {
        const regionParam = {
          group_id: params.groupId,
          status: ContactStatus.unsubscribe,
        }
        fetchUnsubscribeRegion({
          action: 'count_contact',
          data: regionParam,
        })
      }
    }
  }, [fetchAll, params.groupId])

  useEffect(() => {
    if (reloadSubscriberCount) {
      if (
        params.groupId &&
        params.groupId !== '' &&
        showSubscriberCount &&
        showSubscriberCount === true
      ) {
        if (currentUser?.region === defaultRegion) {
          fetchSubscriber({
            groupId: params.groupId,
            status: ContactStatus.subscribe,
          })
        } else {
          const regionParam = {
            group_id: params.groupId,
            status: ContactStatus.unsubscribe,
          }
          fetchUnsubscribeRegion({
            action: 'count_contact',
            data: regionParam,
          })
        }
      }

      if (
        params.groupId &&
        params.groupId !== '' &&
        showUnsubscribeCount &&
        showUnsubscribeCount === true
      ) {
        if (currentUser?.region === defaultRegion) {
          fetchUnsubscribe({
            groupId: params.groupId,
            status: ContactStatus.unsubscribe,
          })
        } else {
          const regionParam = {
            group_id: params.groupId,
            status: ContactStatus.unsubscribe,
          }
          fetchUnsubscribeRegion({
            action: 'count_contact',
            data: regionParam,
          })
        }
      }

      setReloadSubscriberCount(false)
    }
  }, [reloadSubscriberCount])

  const activePanel = (status: string | undefined) => {
    return params.status === status ? 'border border-primary' : ''
  }

  let totalCountUnsubscribe = 0
  let totalCountSubscriber = 0
  let totalCountAll = 0

  let isLoadingCountAll = false
  let isLoadingSubscriber = false
  let isLoadingUnsubscribe = false

  if (currentUser?.region === defaultRegion) {
    totalCountUnsubscribe = countUnsubscribe ? countUnsubscribe.data : 0
    totalCountSubscriber = countSubscriber ? countSubscriber.data : 0
    totalCountAll = countAll ? countAll.data : 0
    isLoadingCountAll = isCountAllLoading
    isLoadingSubscriber = isCountSubscriberLoading
    isLoadingUnsubscribe = isCountUnsubscribeLoading
  } else {
    totalCountUnsubscribe = countUnsubscribeRegion ? countUnsubscribeRegion.data : 0
    totalCountSubscriber = countSubscriberRegion ? countSubscriberRegion.data : 0
    totalCountAll = countAllRegion ? countAllRegion.data : 0
    isLoadingCountAll = isCountAllRegionLoading
    isLoadingSubscriber = isCountSubscriberRegionLoading
    isLoadingUnsubscribe = isCountUnsubscribeRegionLoading
  }

  return (
    <div className='row pb-3'>
      {showAllCount && (
        <div
          className='col-md-4 mb-5 mb-md mb-0 cursor-pointer'
          onClick={() => {
            setParams({groupId: params.groupId, page: ''})
            setTriggerFetch(true)
          }}
        >
          <div className={`card SubscriberModuleTopData ${activePanel(undefined)}`}>
            {isLoadingCountAll ? (
              <div className='row flex-center h-200 w-100'>
                <Spinner />
              </div>
            ) : (
              <div className='dataLeft'>
                {activePanel(undefined) ? (
                  <img
                    src={toAbsoluteUrl('/media/icons/users.png')}
                    className='subscriberImage'
                    alt='poster'
                    width={50}
                    height={50}
                  />
                ) : (
                  <img
                    src={toAbsoluteUrl('/media/icons/users_not_active.png')}
                    className='subscriberImage'
                    alt='poster'
                    width={45}
                    height={45}
                  />
                )}

                <div className=''>
                  <h1>{totalCountAll}</h1>
                  <span>All Contacts</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showSubscriberCount && (
        <div
          className='col-md-4  mb-5 mb-md mb-0 cursor-pointer'
          onClick={() => {
            setParams({
              groupId: params.groupId,
              page: '',
              status: ContactStatus.subscribe,
            })
            setTriggerFetch(true)
          }}
        >
          <div className={`card SubscriberModuleTopData ${activePanel(ContactStatus.subscribe)}`}>
            {isLoadingSubscriber ? (
              <div className='row flex-center h-200 w-100'>
                <Spinner />
              </div>
            ) : (
              <div className='dataLeft'>
                {activePanel(ContactStatus.subscribe) ? (
                  <img
                    src={toAbsoluteUrl('/media/icons/check.png')}
                    className='subscriberImage'
                    alt='poster'
                    width={50}
                    height={50}
                  />
                ) : (
                  <img
                    src={toAbsoluteUrl('/media/icons/check_not_active.png')}
                    className='subscriberImage'
                    alt='poster'
                    width={50}
                    height={50}
                  />
                )}

                <div className=''>
                  <h1>{totalCountSubscriber}</h1>
                  <span>Subscriber</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showUnsubscribeCount && (
        <div
          className='col-md-4 mb-5 mb-md mb-0 cursor-pointer'
          onClick={() => {
            setParams({
              groupId: params.groupId,
              page: '',
              status: ContactStatus.unsubscribe,
            })
            setTriggerFetch(true)
          }}
        >
          <div className={`card SubscriberModuleTopData ${activePanel(ContactStatus.unsubscribe)}`}>
            {isLoadingUnsubscribe ? (
              <div className='row flex-center h-200 w-100'>
                <Spinner />
              </div>
            ) : (
              <div className='dataLeft'>
                {activePanel(ContactStatus.unsubscribe) ? (
                  <img
                    src={toAbsoluteUrl('/media/icons/x.png')}
                    className='subscriberImage'
                    alt='poster'
                    width={50}
                    height={50}
                  />
                ) : (
                  <img
                    src={toAbsoluteUrl('/media/icons/x_not_active.png')}
                    className='subscriberImage'
                    alt='poster'
                    width={50}
                    height={50}
                  />
                )}

                <div className=''>
                  <h1>{totalCountUnsubscribe}</h1>
                  <span>Unsubscribed</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

ContactCountPanel.defaultProps = {
  showAllCount: true,
  showSubscriberCount: true,
  showUnsubscribeCount: true,
}

export default memo(ContactCountPanel)
